import {
  Badge,
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  DeleteOutline,
  EditOutlined,
  ExpandLessRounded,
  ExpandMoreRounded,
  QuestionAnswerOutlined,
  WarningAmberOutlined,
} from "@mui/icons-material";

const GroupAccordian = ({
  collapse,
  expandable,

  TransactionID,
  type,
  title,
  caption,
  ParameterDescription,
  parameterItemNumber,
  parameterWeight,
  children,

  permissions,
  rules,

  clickable,
  onClickHandler,

  editModalHandler,
  deleteModalHandler,
  commentsModalHandler,
  getCommentsCount,
  dataError,
}) => {
  const [open, setOpen] = useState(!collapse);
  const theme = useTheme();

  useEffect(() => {
    setOpen(!collapse);
  }, [collapse]);

  const commentsCount = getCommentsCount
    ? getCommentsCount(parameterItemNumber)
    : 0;

  return (
    <Box sx={{ width: "100%", margin: "" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0.5rem",
          cursor: clickable && "pointer",
          borderRadius: "6px",
          boxShadow: "0px 0px 6px #B1AEBB",
          margin: "0.5em",
          marginRight: "0",
          backgroundColor:
            type === "ph" ? theme.palette.primary["50"] : "white",
        }}
        onClick={
          clickable
            ? () => {
                onClickHandler(TransactionID);
              }
            : () => {}
        }
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1em",
          }}
        >
          <IconButton
            sx={{ marginRight: "0.5em" }}
            onClick={() => {
              setOpen(!open);
            }}
            size="small"
          >
            {expandable && !open && (
              <ExpandMoreRounded fontSize="medium" sx={{ color: "black" }} />
            )}
            {expandable && open && (
              <ExpandLessRounded fontSize="medium" sx={{ color: "black" }} />
            )}
          </IconButton>
          <Stack rowGap={"0.3rem"}>
            <Typography variant={`${type === "g2" ? "h4" : "subtitle"}`}>
              {title || "Unnamed Parameter"}
            </Typography>
            <Typography variant="caption">{ParameterDescription}</Typography>
            {parameterWeight && permissions.addable && (
              <Typography variant="caption" fontWeight={600}>
                Weight: {parameterWeight}%
              </Typography>
            )}
          </Stack>
          {dataError && (
            <Tooltip
              children={<WarningAmberOutlined color="error" />}
              title="Rating is missing"
            />
          )}
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {commentsModalHandler && (
            <IconButton
              onClick={() => commentsModalHandler(parameterItemNumber)}
            >
              <Badge
                badgeContent={commentsCount}
                color="primary"
                overlap="circular"
                sx={{
                  "& .MuiBadge-badge": {
                    fontSize: "0.7rem",
                    height: "1rem",
                    minWidth: "1rem",
                  },
                }}
              >
                <QuestionAnswerOutlined sx={{ color: "#6c6d6f" }} />
              </Badge>
            </IconButton>
          )}
          {permissions?.editable && (
            <IconButton
              onClick={(event) => editModalHandler(event, TransactionID)}
            >
              <EditOutlined sx={{ color: "#6c6d6f" }} />
            </IconButton>
          )}
          {permissions?.deletable && (
            <IconButton
              onClick={(event) => deleteModalHandler(event, TransactionID)}
            >
              <DeleteOutline sx={{ color: "#6c6d6f" }} />
            </IconButton>
          )}
        </Box>
      </Box>
      {open && (
        <Box
          sx={{
            borderTop: 0,
            paddingLeft: "6em",
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  );
};

export default GroupAccordian;
